module.exports = __webpack_public_path__ + "img/f4548d706b1e4499ab45676fb2f0913a-1440.3508fc14.jpg";